<template>
  <el-table :data="tableData" stripe style="width: 100%" height="300px">
    <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        show-overflow-tooltip
    >
      <template v-if="col.prop === 'DTCreatedDate'" #default="scope">
        {{ formatDate(scope.row.DTCreatedDate) }}
      </template>
      <template v-if="col.prop === 'IntStatus'" #default="scope">
        {{ scope.row.IntStatus==0?"未处理":"已处理" }}
      </template>
    </el-table-column>

    <!-- 具名插槽：操作列 -->
    <el-table-column label="操作" width="200px" fixed="right">
      <template #default="scope">
        <slot name="actions" :row="scope.row"></slot>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: Array
  },
  data() {
    return {
      columns: [
        { prop: "StrBookBarcode", label: "图书条码"},
        { prop: "StrPositiveTitle", label: "正题名"},
        { prop: "StrLibraryName", label: "所属书屋"},
        { prop: "StrReaderCardNumber", label: "读者卡号"},
        { prop: "StrReaderName", label: "姓名"},
        { prop: "FloatFineAmount", label: "罚款金额(元)"},
        { prop: "DTCreatedDate", label: "操作时间"},
        { prop: "StrCreatorName", label: "操作员"},
        { prop: "IntStatus", label: "是否处置"},
      ]
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>
